import ModuleWrapper from 'shared-lib/containers/Module';

const FraudProtection = () => import(/* webpackChunkName: "fraud-protection" */ '@/views/fraudProtection/FraudProtection');

const meta = (data = {}) => ({
    permissionsModuleName: 'fraud_protection',
    title: 'Fraud protection',
    auth: true,
    customGuard: (store) => store?.getters?.isFraudProtectionAvailable,
    ...data,
});

export default [{
    path: 'fraud-protection',
    component: ModuleWrapper,
    meta: meta(),
    children: [
        {
            path: '',
            name: 'FraudProtection',
            component: FraudProtection,
            props: true,
            meta: meta(),
        },
    ],
}];
